import React from "react";
import { HorizontalLayoutLayoutWrap } from "./styles";

let HorizontalLayout = ({ children, alignment = "flex-start" }) => {
  return <HorizontalLayoutLayoutWrap alignment={alignment}>{children}</HorizontalLayoutLayoutWrap>;
};

export { HorizontalLayout };
